import ChevronDownFilled from './src/chevron-down-filled';
export default ChevronDownFilled;